import { render } from "./App.vue?vue&type=template&id=bb2b15fa"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=bb2b15fa&lang=css"
script.render = render

export default script